@let numberOfPassengers = mappedPassengers().length;

@if (numberOfPassengers > 1) {
  <fcom-carousel
    #buttonCarousel
    [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
    [nextButtonAriaLabel]="'carousel.next' | finLocalization"
  >
    <div class="ps-small" data-testid="passengers-list" role="tablist" [attr.aria-owns]="tabIds()">
      <fcom-button
        [id]="getTabId(null)"
        [text]="'shoppingCart.allPassengersButton' | finLocalization"
        [theme]="!selectedPassengerId() ? ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE : ButtonTheme.LIGHT_TERTIARY_GHOST"
        [aria]="{
          role: 'tab',
          label: 'shoppingCart.allPassengersButtonAria' | finLocalization,
          selected: selectedPassengerId() === null,
          posinset: 1,
          setsize: numberOfPassengers + 1,
          controls: 'sc-pax-panel',
        }"
        (clickBtn)="selectPassenger(null)"
      ></fcom-button>
      @for (passenger of mappedPassengers(); track passenger.id) {
        <fcom-button
          [id]="getTabId(passenger.id)"
          class="ms-xsmall-l"
          data-hj-masked
          data-dd-privacy="mask"
          [theme]="
            selectedPassengerId() === passenger.id
              ? ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE
              : ButtonTheme.LIGHT_TERTIARY_GHOST
          "
          [text]="passenger.buttonLabel | async"
          [aria]="{
            role: 'tab',
            selected: selectedPassengerId() === passenger.id,
            posinset: $index + 2,
            setsize: numberOfPassengers + 1,
            controls: 'sc-pax-panel',
          }"
          (clickBtn)="selectPassenger(passenger.id)"
        ></fcom-button>
      }
    </div>
  </fcom-carousel>
}
